import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import * as BackstageConstants from '../constants';
import * as D from '../deps';

import BackstageSocialLinkButtonRow from './BackstageSocialLinkButtonRow';

const BackstageAbout = props => {
  const {
    pandoraId,
    bio,
    socialLinks,
    backgroundImgUrl,
    backgroundImgAlt,
    isMobileWeb,
    shareableUrlPath,
    isFirstSection,
    currentPathName,
  } = props;
  const hasSocialLinks = Object.values(socialLinks).some(value => !!value);

  const linkUrl = D.getBackstageFullBioPathForShareUrl(
    shareableUrlPath,
    pandoraId,
    currentPathName,
  );

  const socialLinksContent = hasSocialLinks && (
    <BackstageSocialLinkButtonRow
      hasBackgroundImg={!!backgroundImgUrl && bio}
      {...props.socialLinks}
    />
  );

  return (
    <React.Fragment>
      {(bio || (!isMobileWeb && socialLinksContent)) && (
        <D.ContentSection
          title={bio ? <FormattedMessage {...BackstageConstants.messages.about} /> : null}
          backgroundImgUrl={backgroundImgUrl}
          backgroundImgAlt={backgroundImgAlt}
          isAbout={true}
          moreText={isMobileWeb && <FormattedMessage {...BackstageConstants.messages.readMore} />}
          moreUrl={isMobileWeb && linkUrl}
          isFirstSection={isFirstSection}
        >
          <D.DescriptionBackstageWithLogger
            pandoraId={pandoraId}
            text={bio}
            linkUrl={linkUrl}
            linkText={BackstageConstants.messages.readMore}
            isExpanded={false}
            shortTextWidthRatio={2}
            hasBackgroundImg={!!backgroundImgUrl}
            shouldShowSeeMore={!isMobileWeb}
          />
          {!isMobileWeb && socialLinksContent}
        </D.ContentSection>
      )}
      {isMobileWeb && socialLinksContent && (
        <D.ContentSection title={<FormattedMessage {...BackstageConstants.messages.links} />}>
          {socialLinksContent}
        </D.ContentSection>
      )}
    </React.Fragment>
  );
};

BackstageAbout.propTypes = {
  pandoraId: PropTypes.string,
  bio: PropTypes.string,
  shareableUrlPath: PropTypes.string,
  backgroundImgUrl: PropTypes.string,
  backgroundImgAlt: PropTypes.string,
  shortTextWidthRatio: PropTypes.number,
  socialLinks: PropTypes.shape({
    twitterUrl: PropTypes.string,
    instagramUrl: PropTypes.string,
    facebookUrl: PropTypes.string,
    websiteUrl: PropTypes.string,
  }),
  isFirstSection: PropTypes.bool,
  isMobileWeb: PropTypes.bool,
  currentPathName: PropTypes.string,
};

export function mapStateToProps(state) {
  return {
    isMobileWeb: D.isMobileWeb(state),
    currentPathName: D.getCurrentPathnameFromState(state),
  };
}

export default connect(mapStateToProps)(BackstageAbout);
